<template>
    <a class="msg-file-card"
       data-cy="attachment-file-card"
       :href="href"
       target="_blank"
       rel="noopener"
       :title="attachment.name">
        <i class="msg-file-card__icon" :class="iconClass" aria-hidden="true"></i>
        <span class="msg-file-card__meta">
            <span class="msg-file-card__name">{{ attachment.name }}</span>
            <span class="msg-file-card__sub">{{ subtitle }}</span>
        </span>
        <i class="fa-solid fa-download msg-file-card__action" aria-hidden="true"></i>
    </a>
</template>

<script>
import { iconForAttachment, extensionFor, formatSize } from '../utilities/attachment_types';

export default {
  name: 'attachment',
  props: {
    attachment: { type: Object, required: true },
  },
  computed: {
    href() {
      return decodeURI(this.attachment.url);
    },
    iconClass() {
      return iconForAttachment(this.attachment);
    },
    subtitle() {
      const ext = extensionFor(this.attachment);
      // size is only present on in-flight composer uploads (fineuploader knows
      // it); attachments read back from the API carry no byte count, so the
      // extension alone is the subtitle there.
      const size = formatSize(this.attachment.size);
      const label = ext ? ext.toUpperCase() : 'File';
      return size ? `${label} · ${size}` : label;
    },
  },
};
</script>
